/* Credits (brightivity.dev/wallet — M4). */
import { api } from './client.js';

export const getBalance = () => api('/wallet/balance');
export const getPackages = () => api('/wallet/packages');
export const getPricing = () => api('/wallet/pricing');
export const startCheckout = (packageId) => api('/wallet/checkout/create-session', {
  method: 'POST',
  body: { packageId, successUrl: `${location.origin}${location.pathname}?payment=success`, cancelUrl: `${location.origin}${location.pathname}?payment=cancelled` },
});
